export function cleanErrors(state) {
  state.error = false
  state.errorMessage = ''
}

export function saveCoinsInfo(state, data) {
  state.CoinsBanked = data.Banked
  state.CoinsPending = data.Pending
  state.CoinsClaimed = data.Claimed
  state.CoinsByModule = data.Modules
}

export function saveLevelInfo(state, data) {
  state.userLevel = data.userLevel
  state.userPoints = data.userPoints
  state.rankingData = data.ranking
  state.userPosition = data.userPos
  state.LevelImage = data.userLevel.photo
}

export function error(state, payload) {
  state.error = true
  state.errorMessage = payload
}

export function saveProgressInfo(state, data) {
  state.progressDays = data.days
  state.progressInfo = data.value
  state.progressRange = data.range
  //console.log(state.progressRange)
}

export function saveProgressInfoModules(state, data) {
  state.progressInfoModules = data.value
  state.progressDays = data.days
}

export function saveCoinsPending(state, data) {
  state.pendingCoins = data
}

export function setCoinsValues(state, data) {
  state.typeCoinsValues = data
}